// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._DsQQOQtbrsCE6EmNWEA{padding:4.5px 8px;display:inline-block}.az_egS_d02VnTK91Pps4{flex-direction:column;width:100%;margin-left:-26px;padding:24px;display:flex}.a_VLFbMmL0gmg6aEayr3{flex-direction:column;align-items:flex-start;gap:8px;margin-bottom:32px;display:flex}.H2cukvDCezgbLHY_evNU{align-items:center;display:flex}.AEKNgsrkiqw2qe_rIeqF{flex-wrap:wrap;align-items:center;gap:8px;display:flex}.hKaaXnmkoIghllxZcpIg{align-items:center;gap:8px;display:flex}.h1Avg9ueu0oF56moBUpp{min-width:148px}.f98rz8NXXMu_4xxXElCD{padding-right:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"initContentTitle": `_DsQQOQtbrsCE6EmNWEA`,
	"filterEditorDropdownContent": `az_egS_d02VnTK91Pps4`,
	"filtersContainer": `a_VLFbMmL0gmg6aEayr3`,
	"additionalFiltersContainer": `H2cukvDCezgbLHY_evNU`,
	"additionalFilters": `AEKNgsrkiqw2qe_rIeqF`,
	"actions": `hKaaXnmkoIghllxZcpIg`,
	"dropdownContent": `h1Avg9ueu0oF56moBUpp`,
	"dropdownItem": `f98rz8NXXMu_4xxXElCD`
};
export default ___CSS_LOADER_EXPORT___;
